<!--
 * @Author: your name
 * @Date: 2021-09-17 14:32:13
 * @LastEditTime: 2026-07-29 17:06:39
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\login\ResetPd.vue
-->
<template>
  <div class="reset-pd">
    <div class="title flex-c-c">{{ $t('clrp1') }}</div>
    <div class="schedule flex-c-c">
      <span :class="{ 'active': activeRpwd }">{{ $t('clrp2') }}</span> ———>
      <span :class="{ 'active': !activeRpwd }">{{ $t('clrp3') }}</span>
    </div>
    <div class="user-form">
      <el-form :model="user" :rules="rules" ref="userForm" label-width="200px">
        <template v-if="activeRpwd">
          <el-form-item :label="$t('clrp4')" prop="user_name">
            <el-input v-model="user.user_name"></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('clrp5')" prop="email">
            <el-input type="email" v-model="user.email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('clrp6')" prop="email_code">
            <el-input v-model="user.email_code" auto-complete="new-password">
              <template slot="append">
                <span
                  @click="getVerification"
                  class="email-code-hover"
                  style="user-select: none;"
                  v-if="codeTime <= 0"
                >{{$t('clrp7')}}</span>
                <span
                  class="email-code"
                  style="user-select: none; max-width: 110px; text-align: center;"
                  v-if="codeTime > 0"
                >{{codeTime}}{{ $t('clrp8') }}</span>
              </template>
</el-input>
</el-form-item> -->
          <el-form-item v-if="user.vtype" :label="$t('clr5')" prop="email" :error="error.email">
            <el-input type="email" v-model="user.email" @change="(val) => verification('email', val)"></el-input>
          </el-form-item>
          <el-form-item v-else label="电话" prop="phoneNum" :error="error.phoneNum">
            <el-input type="tel" v-model="user.phoneNum" @change="(val) => verification('phoneNum', val)"></el-input>
          </el-form-item>
          <el-form-item prop="email_code" :label="$t('clr6')">
            <div class="flex-b-c">
              <el-input v-model="user.email_code" autocomplete="off">
                <template slot="append">
                  <span @click="user.vtype ? getVerification() : getPhoneCode()"
                    :class="{ 'email-code': error.email_code }" class="email-code-hover" style="user-select: none;"
                    v-if="codeTime <= 0">{{ user.vtype ? "获取邮箱验证码" : "获取手机验证码"
                    }}</span>
                  <span class="email-code" style="user-select: none; max-width: 110px; text-align: center;"
                    v-if="codeTime > 0">{{ codeTime }}{{ $t('clr8') }}</span>
                </template>
              </el-input>
              <el-button type="primary" style="width: 126px;margin-left: 16px;" @click="() => {
                this.user.vtype = !this.user.vtype; this.codeTime = 0;
              }" round>{{ user.vtype ? '切换手机验证' : '切换邮箱验证' }}</el-button>
            </div>
          </el-form-item>
        </template>
        <!-- 重置密码设置 -->
        <template v-if="!activeRpwd">
          <el-form-item :label="$t('clrp9')" prop="password">
            <el-input v-model="user.password" type="password" auto-complete="new-password"></el-input>
          </el-form-item>
          <el-form-item :label="$t('clrp10')" prop="rpassword">
            <el-input v-model="user.rpassword" type="password" auto-complete="new-password"></el-input>
          </el-form-item>
        </template>
        <el-form-item label-width="50px">
          <el-button type="primary" @click="submitForm('userForm')" round>{{ $t('clrp11') }}</el-button>
        </el-form-item>
        <el-form-item label-width="30px">
          <div @click="setShowType" class="re-login">
            <span>{{ $t('clrp12') }}?</span>&nbsp;
            <span style="color: #606266;">{{ $t('clrp13') }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import isPasswordValid from '@/assets/scripts/isPasswordValid.js'
export default {
  // admin/nindex/forgetPwdGetCode
  //  user_name: this.addForm.name,
  //     email: this.addForm.email


  // email_code: 1234
  // email: 1047143112@qq.com
  // admin/nindex/forgetPwdConfirmCode


  // let formData = {
  //       user_name: this.addForm.name,
  //       email: this.addForm.email,
  //       pwd: encodeURIComponent(JSON.stringify([this.addForm.pass, this.addForm.checkPass])),
  //       email_code: this.addForm.verificationCode
  //     };
  //     let URL = "/admin/nindex/forgetPwdReset";
  name: 'ResetPd',
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('clrp14')));
      } else if (value !== this.user.password) {
        this.user.rpassword = "";
        callback(new Error(this.$t('clrp15')));
      } else {
        callback();
      }
    };
    let passStrength = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!isPasswordValid(value)) {
        callback(new Error("密码至少8位至少需要包含字母数字特殊符号其中2种"));
      } else {
        callback();
      }
    };
    return {
      codeTime: 0,
      intervalTime: null,
      activeRpwd: true,
      error: {
        email: "",
        email_code: true,
        phoneNum: ''
      },
      user: {
        user_name: "",
        email_code: "",
        email: "",
        phoneNum: '',
        password: "",
        rpassword: "",
        vtype: false
      },
      rules: {
        user_name: [{ required: true, message: this.$t('clrp16'), trigger: 'blur' }],
        email_code: [{ required: true, message: this.$t('clrp18'), trigger: 'change' }],
        password: [{ validator: passStrength, trigger: 'blur' }],
        rpassword: [{ validator: validatePass, trigger: 'blur' }],
      }
    }
  },
  methods: {
    setShowType() {
      this.$emit("setShowType");
    },
    verification(key, val) {
      let reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let phoneReg = /^1[3-9]\d{9}$/;
      if (key === 'email') {
        if (reg.test(val)) {
          this.error.email = "";
          this.error.email_code = false;
        } else {
          this.error.email = this.$t('clrp17');
          this.error.email_code = true;
        }
      } else if (key === 'phoneNum') {
        if (phoneReg.test(val)) {
          this.error.phoneNum = "";
          this.error.email_code = false;
        } else {
          this.error.phoneNum = this.$t('clr25');
          this.error.email_code = true;
        }
      }
    },
    getVerification() {
      if (!this.user.user_name) {
        this.$msg({ message: this.$t('clrp16'), type: "error", showClose: true });
        return;
      }
      if (!this.user.email) {
        this.$msg({ message: this.$t('clrp17'), type: "error", showClose: true });
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.user.email)) {
        this.$msg({ message: this.$t('clrp17'), type: "error", showClose: true });
        return;
      }
      this.codeTime = 120;
      this.$http.post("/admin/nindex/forgetPwdGetCode", {
        email: this.user.email,
        user_name: this.user.user_name,
        timeout: 300
      }, (res) => {
        const { status, tips } = res;
        if (status !== 1) {
          this.$msg({ message: tips, type: "error", showClose: true });
        } else {
          this.$msg({ message: this.$t('clrp20'), type: "success", showClose: true });
        }
      });
      this.intervalTime = setInterval(() => {
        if (this.codeTime > 0) {
          this.codeTime -= 1
        } else {
          clearInterval(this.intervalTime);
        }
      }, 1000);
    },
    getPhoneCode() {
      if (!this.user.user_name) {
        this.$msg({ message: this.$t('clrp16'), type: "error", showClose: true });
        return;
      }
      if (!this.user.phoneNum) {
        this.$msg({ message: this.$t('clr25'), type: "error", showClose: true });
        return;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.user.phoneNum)) {
        this.$msg({ message: this.$t('clr25'), type: "error", showClose: true });
        return;
      }
      this.codeTime = 120;
      this.$http.post("/admin/nindex/forgetPwdMobileGetCode", {
        user_name: this.user.user_name,
        phone: this.user.phoneNum,
        timeout: 300
      }, (res) => {
        const { status, tips } = res;
        if (status !== 1) {
          this.$msg({ message: tips, type: "error", showClose: true });
        } else {
          this.$msg({ message: this.$t('clr23'), type: "success", showClose: true });
        }
      });
      this.intervalTime = setInterval(() => {
        if (this.codeTime > 0) {
          this.codeTime -= 1
        } else {
          clearInterval(this.intervalTime);
        }
      }, 1000);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.user);
          if (this.activeRpwd) {
            if (this.user.vtype) {
              this.$http.post("/admin/nindex/forgetPwdConfirmCode", {
                email: this.user.email,
                email_code: this.user.email_code
              }, (res) => {
                if (res.status) {
                  this.$msg({ message: res.tips, type: "warning", showClose: true });
                } else {
                  this.activeRpwd = false;
                }
              });
            } else {
              this.$http.post("/admin/nindex/forgetPwdMobileConfirmCode", {
                phone: this.user.phoneNum,
                phone_code: this.user.email_code
              }, (res) => {
                if (res.status) {
                  this.$msg({ message: res.tips, type: "warning", showClose: true });
                } else {
                  this.activeRpwd = false;
                }
              });
            }
          } else {
            if (this.user.vtype) {
              let { user_name, email, email_code } = this.user;
              let pwd = encodeURIComponent(JSON.stringify([this.user.password, this.user.rpassword]));
              this.$http.post("/admin/nindex/forgetPwdReset", {
                user_name,
                email,
                email_code,
                pwd
              }, (res) => {
                if (res.status) {
                  this.$msg({ message: res.tips, type: "warning", showClose: true });
                } else {
                  this.activeRpwd = true;
                  this.$emit("setShowType");
                }
              });
            } else {
              let { user_name, phoneNum, email_code } = this.user;
              let pwd = encodeURIComponent(JSON.stringify([this.user.password, this.user.rpassword]));
              this.$http.post("/admin/nindex/forgetPwdMobileReset", {
                user_name,
                phone: phoneNum,
                phone_code: email_code,
                pwd
              }, (res) => {
                if (res.status) {
                  this.$msg({ message: res.tips, type: "warning", showClose: true });
                } else {
                  this.activeRpwd = true;
                  this.$emit("setShowType");
                }
              });
            }
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style lang="scss" scoped>
.reset-pd {
  background-color: #fff;
  padding-bottom: 20px;
  border-radius: 8px;
  width: 600px;
  overflow: hidden;

  .title {
    height: 50px;
    font-size: 20px;
    color: #fff;
    background-image: linear-gradient(270deg,
        #86eae7 0%,
        #4cccf0 45%,
        #11adf8 100%),
      linear-gradient(#ffffff, #ffffff);
    background-blend-mode: normal, normal;
  }

  .schedule {
    height: 60px;

    .active {
      color: #2898ff;
    }
  }

  .user-form {
    padding-right: 30px;
    // padding-top: 10px;
    background-color: #fff;

    .el-form-item+.el-form-item {
      margin-top: 20px;
    }

    /deep/ .el-input-group__append {
      border-radius: 0px 20px 20px 0px;
    }

    /deep/ .el-input-group__append,
    .el-input-group__prepend {
      background-color: var(--theme-color-customized-1);
      color: #fff;
    }


    .re-login {
      text-align: center;
      line-height: 10px;
      cursor: pointer;
    }

    .email-code {
      cursor: not-allowed;
    }

    .email-code-hover {
      cursor: pointer;
    }
  }
}
</style>